import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SharedService } from '../shared/shared.service';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
// implements CanActivate
export class PostLoginService implements CanActivate{



  SERVER_URL= environment.backend_server;

  auth_key:any;
  user_data:any={};

  constructor(
    public http:HttpClient,
    public router:Router,
    private shared_service:SharedService,
    private auth_service:AuthenticationService,
    private route:ActivatedRoute
  ) { }


  canActivate(route:ActivatedRouteSnapshot,state:RouterStateSnapshot):boolean | Observable<boolean> | Promise<boolean | UrlTree>{
    
    return new Promise (res =>{ 

      if(this.auth_service.isLoggedIn()['isLoggedIn']){

        const userType = this.auth_service.isLoggedIn()['user_data']['type_1'];
        if(userType == 'Admin'){
          res(true);
        } else if(userType == 'Befriender'){
          this.router.navigate(['/befriender/dashboard']);
          res(false);
        } else{
          this.router.navigate(['/community']);
          res(false);
        }
        
        // this.shared_service.getUserData.subscribe(user_data =>{

        //   if(user_data['type_1']=='Admin'){   
            
        //     res(true);
        //   }
          
        //   // else{
  
        //   //    this.auth_service.removeTokenSession();
        //   //    this.router.navigate(['/login']);
        //   //    res(false);
        //   //  }
         
        // });
  
         
        
      }else{
        
        this.router.navigate(['/login']);
        res(false);
      }


    });


  }
}
